import "../../Styles/Sass/header-buttons.scss";

function replaceHeaderButtons(replacementHtml) {
	document.querySelectorAll('.login-menu').forEach((menu) => {
		menu.outerHTML = replacementHtml;
	});
	$('.login-menu').foundation();
}

// Get login buttons. The buttons are loaded in HTML; this is only here in case buttons cached
fetch('/MicrosoftIdentity/Account/LoginButtons')
	.then((response) => {
		if (response.ok) {
			return response.text();
		}
		// This call may return a 304, in which case we should do nothing
		return Promise.resolve(null);
	})
	.then((html) => {
		if (html) {
			if (document.querySelectorAll('.login-menu').length >= 2) {
				replaceHeaderButtons(html);
			}
			else {
				// if menu isn't loaded by the time this runs, set interval to wait for it
				const menuWait = setInterval(() => {
					if (document.querySelectorAll('.login-menu').length >= 2) {
						replaceHeaderButtons(html);
						clearInterval(menuWait);
					}
				}, 25);
			}
		}
	});